/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { RecurrenceRequest } from './recurrenceRequest';

export type AppointmentSlotRecurrence = RecurrenceRequest | null;
